<template>
  <div style="height: 100%">
    <ul class="table_title">
      <li style="width: 25%">昵称</li>
      <li style="width: 25%">手机号</li>
      <li style="width: 25%">订单状态</li>
      <li style="width: 25%">操作</li>
    </ul>
    <div class="table_content">
      <div v-for="(item, index) in orderList" :key="'order'+index" class="table_list">
        <ul class="order_ul">
          <li>订单编号：{{ item.orderNumber }}</li>
          <li>订单时间：{{ item.createTime }}</li>
          <li>订单金额：￥{{ item.orderPrice }}</li>
        </ul>
        <div>
          <ul class="order_detail_ul">
            <li style="width: 25%">{{ item.nickname }}</li>
            <li style="width: 25%">{{ item.phone }}</li>
            <li style="width: 25%">
              {{ statusList[item.status] }}
            </li>
            <li style="width: 25%">
              <span style="color:#FF4D4D" @click="cancelOrder(item.id)" v-show="item.status !== 4">取消订单</span>
              <span @click="detailOrder(item)">订单详情</span>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="orderList.length === 0" style="text-align: center;padding: 20px;color: #999">暂无订单</div>
    </div>

    <el-dialog title="订单详情" width="800px" :visible.sync="detailVisible">
      <el-form label-width="150px">
        <el-form-item label="昵称：">{{ detailData.nickname }}</el-form-item>
        <el-form-item label="手机号：">{{ detailData.phone }}</el-form-item>
        <el-form-item label="订单编号：">{{ detailData.orderNumber }}</el-form-item>
        <el-form-item label="订单金额：">￥{{ detailData.orderPrice }}</el-form-item>
        <el-form-item label="订单状态：">{{ statusList[detailData.status] }}</el-form-item>
        <el-form-item label="订单时间：">{{ detailData.createTime }}</el-form-item>
        <el-form-item label="赛事名称：">{{ detailData.eventManagementName }}</el-form-item>
        <el-form-item label="参赛项目：">{{ detailData.eventEntriesName }}</el-form-item>
        <el-form-item label="报名时间：">{{ detailData.eventApplyTime }}</el-form-item>
        <el-form-item label="比赛时间：">{{ detailData.eventTime }}</el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { get } from '@/utils/request'

export default {
  name: "tableEvnetOrder",
  props: {
    orderList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      statusList: ['', '待付款', '待使用', '已完成', '已取消', '已退款'],
      detailVisible: false,
      detailData: {}
    }
  },
  methods: {
    cancelOrder(id) {
      this.$confirm('确认取消该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        get('/gateway/order-table/cancellation?id=' + id).then(res => {
          if (res.code === 0) {
            this.$message.success('取消成功')
            this.$emit('getData')
          }
        })
      }).catch(() => {});
    },

    detailOrder (item) {
      this.detailData = item
      this.detailVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.table_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #EFEFEF;
  border: 1px solid #DCDCDC;
  border-bottom: none;
  margin: 0;
  padding: 0;

  li {
    list-style: none;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
  }
}

.table_content {
  overflow-y: auto;
  height: calc(100% - 80px);
}

.table_list {
  margin-bottom: 10px;
}

.order_ul {
  display: flex;
  align-items: center;
  margin: 0;
  //justify-content: space-between;
  background-color: #F9F9F9;
  border-left: 1px solid #DCDCDC;
  border-right: 1px solid #DCDCDC;
  border-top: 1px solid #DCDCDC;
  padding: 0 5%;

  li {
    list-style: none;
    display: flex;
    align-items: center;
    //justify-content: center;
    height: 52px;
    font-weight: 700;
    font-size: 20px;
    color: #333333;
    margin-right: 20px;
  }
}

.order_detail_ul {
  margin: 0;
  display: flex;
  justify-content: space-between;
  border: 1px solid #DCDCDC;
  padding: 0;

  li {
    list-style: none;
    min-height: 52px;
    width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #DCDCDC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    padding: 10px 0;

    &:last-child {
      border: none;
    }

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #DCDCDC;
      margin: 0;
      width: 100%;
      height: 52px;

      &:last-child {
        border: none;
      }
    }

    span {
      cursor: pointer;
      margin-bottom: 10px;
      color: #0058A6;

      &:last-child {
        margin: 0;
      }
    }
  }
}
</style>
